import { createComponentConfig, KoStandaloneControl } from '../../../pro-customizables/ko-components/control-base.js';
class AmeAcSeparator extends KoStandaloneControl {
    constructor(params, $element) {
        super(params, $element);
    }
}
export default createComponentConfig(AmeAcSeparator, `
	<li class="ame-ac-control ame-ac-separator"></li>
`);
//# sourceMappingURL=ame-ac-separator.js.map